const initialState = {
    //emp List 
    loadingLeadStatus: false,
    leadStatusDataError: "",
    leadStatusData: [],
    leadStatusCurrentPage: 0,
    leadStatusTotalPage: 0,
    leadStatusTotalData: 0,
    leadAllStatusCount: {},
    leadStatusPickedUser: {},

    //downline List 
    loadingDownline: false,
    DownlineError: "",
    Downline: [],
    DownlineCurrentPage: 0,
    DownlineTotalPage: 0,
    DownlineTotalData: 0,


    //quote details
    loadingQuoteDetail: false,
    quoteDetailDataError: "",
    quoteDetailData: [],

    //pricing quote details
    loadingPricingQuoteDetail: false,
    pricingQuoteDetailDataError: "",
    pricingQuoteDetailData: [],

}

const LeadStatusReducer = (state = initialState, action) => {
    switch (action.type) {

        //pickedRateReq List//
        case 'FIND_LEAD_STATUS_REQUEST':
            return {
                ...state,
                loadingLeadStatus: true,
                leadStatusData: [],
                leadStatusDataError: '',
                leadStatusPickedUser: {}
            };
        case 'FIND_LEAD_STATUS_SUCCESS':
            return {
                ...state,
                loadingLeadStatus: false,
                leadStatusData: action.payload.data,
                leadStatusCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                leadStatusTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 1,
                leadStatusTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 1,
                leadAllStatusCount: action.payload.getCount,
                leadStatusPickedUser: action.payload.picked_user_data
            };
        case 'FIND_LEAD_STATUS_FAILURE':
            return {
                ...state,
                loadingLeadStatus: false,
                leadStatusDataError: action.payload,
            };
        //emp List//

        //downline list List//
        case 'FIND_DOWNLINE_LIST_REQUEST':
            return {
                ...state,
                loadingDownline: true,
                DownlineData: [],
                DownlineDataError: '',
            };
        case 'FIND_DOWNLINE_LIST_SUCCESS':
            return {
                ...state,
                loadingDownline: false,
                DownlineData: action.payload.data,
                DownlineCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                DownlineTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 1,
                DownlineTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 1,
            };
        case 'FIND_DOWNLINE_LIST_FAILURE':
            return {
                ...state,
                loadingDownline: false,
                DownlineDataError: action.payload,
            };
        //downline List//

        //quote details List//
        case 'FIND_QUOTE_DETAIL_REQUEST':
            return {
                ...state,
                loadingQuoteDetail: true,
                quoteDetailData: {},
                quoteDetailDataError: '',
            };
        case 'FIND_QUOTE_DETAIL_SUCCESS':
            return {
                ...state,
                loadingQuoteDetail: false,
                quoteDetailData: action.payload,
            };
        case 'FIND_QUOTE_DETAIL_FAILURE':
            return {
                ...state,
                loadingQuoteDetail: false,
                quoteDetailDataError: action.payload,
            };
        //quote details//

        //quote pricing details List//
        case 'FIND_PRICING_QUOTE_DETAIL_REQUEST':
            return {
                ...state,
                loadingPricingQuoteDetail: true,
                pricingQuoteDetailData: {},
                pricingQuoteDetailDataError: '',
            };
        case 'FIND_PRICING_QUOTE_DETAIL_SUCCESS':
            return {
                ...state,
                loadingPricingQuoteDetail: false,
                pricingQuoteDetailData: action.payload,
            };
        case 'FIND_PRICING_QUOTE_DETAIL_FAILURE':
            return {
                ...state,
                loadingPricingQuoteDetail: false,
                pricingQuoteDetailDataError: action.payload,
            };
        //quote pricing details List//

        //Job Order List//
        // case 'FIND_JOB_ORDER_LIST_CC_REQUEST':
        //     return {
        //         ...state,
        //         loadingJobOrderListCCStatus: true,
        //         jobOrderListCCData: [],
        //         jobOrderListCCDataError: '',
        //     };
        // case 'FIND_JOB_ORDER_LIST_CC_SUCCESS':
        //     return {
        //         ...state,
        //         loadingJobOrderListCC: false,
        //         jobOrderListCCData: action.payload.data,
        //         leadStatusCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
        //         leadStatusTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 1,
        //         leadStatusTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 1,
        //         leadAllStatusCount: action.payload.getCount,
        //     };
        // case 'FIND_JOB_ORDER_LIST_CC_FAILURE':
        //     return {
        //         ...state, 
        //         loadingJobOrderListCC: false,
        //         jobOrderListCCDataError: action.payload,
        //     };
        // //Job Order List//



        default:
            return state;
    }
}

export default LeadStatusReducer;